export const fieldsConfig = {
  applicantName: { label: "Select Company", type: "company" },
  applicantMobile: { label: "Applicant Number", type: "text" },
  applicantEmail: { label: "Applicant Email", type: "email" },
  buyerName: { label: "Buyer Name", type: "text" },
  buyerMobile: { label: "Buyer Number", type: "text" },
  buyerEmail: { label: "Buyer Email", type: "email" },
  diaryNo: { label: "Diary No.", type: "text" },
  amount: { label: "Amount", type: "number" },
  loginId: { label: "Portal login", type: "text" },
  portalPassword: { label: "Password", type: "password" },
  caseNo: { label: "Case No.", type: "text" },
  status: {
    label: "Status",
    type: "select",
    master: "payment_recovery_status",
    options: ["New", "In Progress", "Awarded", "Recovered", "Withdrawn", "Closed"],
  },
  stage: {
    label: "Stage",
    type: "select",
    master: "payment_recovery_stage",
    options: ["Legal Notice", "Rejoinder", "GST Complaint", "ODR", "Hearing", "Arbitration", "Order", "Withdrawal"],
  },
  legalNoticeDate: { label: "Legal Notice Date", type: "date" },
  receiveDate: { label: "Receive Date", type: "date" },
  rejoinderDate: { label: "Rejoinder Date", type: "date" },
  replyToRejoinderDate: { label: "Reply to Rejoinder Date", type: "date" },
  gstComplaintDate: { label: "GST Complaint Date", type: "date" },
  odrCaseDate: { label: "ODR Case Date", type: "date" },
  queryLetterDate: { label: "Query Letter Date", type: "date" },
  replyOfQueryLetterDate: { label: "Reply of Query Letter Date", type: "date" },
  intimationDate: { label: "Intimation Date", type: "date" },
  hearing1: { label: "Hearing 1", type: "date" },
  hearing2: { label: "Hearing 2", type: "date" },
  hearing3: { label: "Hearing 3", type: "date" },
  arbitrationNoteDate: { label: "Arbitration Note Date", type: "date" },
  arbitrationOrder: { label: "Arbitration Order", type: "date" },
  withdrawalCaseDate: { label: "Withdrawal Case Date", type: "date" },
};

export const PaymentrequiredFields = [
  "applicantName",
  "buyerName",
  "diaryNo",
  "amount",
];

export const PaymentFieldGroups = [
  {
    title: "Applicant",
    columns: 3,
    fields: ["applicantName", "applicantMobile", "applicantEmail"],
  },
  {
    title: "Buyer",
    columns: 3,
    fields: ["buyerName", "buyerMobile", "buyerEmail"],
  },
  {
    title: "Case details",
    columns: 3,
    fields: ["diaryNo", "caseNo", "amount"],
  },
  {
    title: "Status and stage",
    columns: 2,
    fields: ["status", "stage"],
  },
  {
    title: "Portal access",
    columns: 2,
    fields: ["loginId", "portalPassword"],
  },
  {
    title: "Notices and replies",
    columns: 3,
    fields: [
      "legalNoticeDate",
      "receiveDate",
      "rejoinderDate",
      "replyToRejoinderDate",
      "gstComplaintDate",
      "odrCaseDate",
      "queryLetterDate",
      "replyOfQueryLetterDate",
      "intimationDate",
    ],
  },
  {
    title: "Hearings and order",
    columns: 3,
    fields: [
      "hearing1",
      "hearing2",
      "hearing3",
      "arbitrationNoteDate",
      "arbitrationOrder",
      "withdrawalCaseDate",
    ],
  },
];

export const INQUIRY_TYPE_OPTIONS = [
  { value: "general", label: "General" },
  { value: "payment_recovery", label: "Payment Recovery" },
  { value: "task", label: "Task" },
  { value: "case_management", label: "Case Management" },
  { value: "gst", label: "GST" },
];


export const GSTfieldsConfig = {
  caseId: { label: "Case No.", type: "text" },
  taxPayerName: { label: "Taxpayer Name", type: "select" , options: [] },
  GSTIN: { label: "GSTIN", type: "text" },
  subject: { label: "Subject", type: "text" },
  amount: { label: "Amount", type: "text" },
  stage: { label: "Stage", type: "select", master: "gst_case_stage", options: ["Notice", "Reply", "Hearing", "Order", "Appeal"] },
  status: {
    label: "Status",
    type: "select",
    master: "gst_case_status",
    options: ["New", "Pending", "Completed", "Closed"],
  },
  assignedTo: { label: "Assigned To", type: "select", options: [] },
  DRC01AReceived: { label: "DRC-01A Received Date", type: "date" },
  replayToDRC01A: { label: "Reply To DRC-01A", type: "text" },
  DRC01CauseDate: { label: "DRC-01 Cause Date", type: "date" },
  replayToDRC01: { label: "Reply To DRC-01", type: "date" },
  additionalClarification: { label: "Additional Clarification", type: "text" },

  hearingNotice: { label: "Hearing Notice Date", type: "date" },
  wrritenSubmissionFiled: { label: "Written Submission Filed", type: "text" },
  hearing1: { label: "Hearing 1", type: "select", master: "gst_hearing_status", options: ["Scheduled", "Completed", "Adjourned", "Cancelled"] },
  hearing2: { label: "Hearing 2", type: "select", master: "gst_hearing_status", options: ["Scheduled", "Completed", "Adjourned", "Cancelled"] },
  hearing3: { label: "Hearing 3", type: "select", master: "gst_hearing_status", options: ["Scheduled", "Completed", "Adjourned", "Cancelled"] },

  orderDate: { label: "Order Date", type: "date" },
  orderPassed: { label: "Order Passed", type: "date" },
  demandStatus: {
    label: "Demand Status",
    type: "select",
    master: "gst_demand_status",
    options: ["Confirmed", "Dropped", "Partial", "Paid"],
  },
  DRC07issued: { label: "DRC-07 Issued", type: "date" },

  appealFiledDate: { label: "Appeal Filed Date", type: "date" },
  appealAckNo: { label: "Appeal Acknowledgment / No.", type: "text" },
  appealHearing1: { label: "Appeal Hearing 1", type: "date" },
  appealHearing2: { label: "Appeal Hearing 2", type: "date" },
  appellateOrderPassed: { label: "Appellate Order Passed", type: "date" },

  highCourtWritFiled: { label: "High Court Writ Filed", type: "date" },
  HCHearing1: { label: "HC Hearing 1", type: "date" },
  HCHearing2: { label: "HC Hearing 2", type: "date" },
  HCHearing3: { label: "HC Hearing 3", type: "date" },
  HCHearing4: { label: "HC Hearing 4", type: "date" },
  highCourtOrder: { label: "High Court Order", type: "date" },
};

export const GSTrequiredFields = [
  "caseId",
  "taxPayerName",
  "GSTIN",
  "subject",
  "amount",
  "stage",
  "status",
  "assignedTo",
  "DRC01AReceived",
];
export const GSTstages = [
  [
    "caseId",
    "taxPayerName",
    "GSTIN",
    "subject",
    "amount",
    "stage",
    "status",
    "assignedTo",
    "DRC01AReceived",
  ],
  ["replayToDRC01A"],
  ["DRC01CauseDate"],
  ["replayToDRC01"],
  ["additionalClarification"],
  ["hearingNotice"],
  ["wrritenSubmissionFiled"],
  ["hearing1"],
  ["hearing2"],
  ["hearing3"],
  ["orderDate"],
  ["orderPassed"],
  ["demandStatus"],
  ["DRC07issued"],
  ["appealFiledDate"],
  ["appealAckNo"],
  ["appealHearing1"],
  ["appealHearing2"],
  ["appellateOrderPassed"],
  ["highCourtWritFiled"],
  ["HCHearing1"],
  ["HCHearing2"],
  ["HCHearing3"],
  ["HCHearing4"],
  ["highCourtOrder"],
];

export const GSTFieldGroups = [
  { title: "Case details", fields: GSTstages[0] },
  {
    title: "DRC-01A / DRC-01",
    fields: ["replayToDRC01A", "DRC01CauseDate", "replayToDRC01", "additionalClarification"],
  },
  {
    title: "Hearing",
    fields: ["hearingNotice", "wrritenSubmissionFiled", "hearing1", "hearing2", "hearing3"],
  },
  { title: "Order", fields: ["orderDate", "orderPassed", "demandStatus", "DRC07issued"] },
  {
    title: "Appeal",
    fields: ["appealFiledDate", "appealAckNo", "appealHearing1", "appealHearing2", "appellateOrderPassed"],
  },
  {
    title: "High Court",
    fields: ["highCourtWritFiled", "HCHearing1", "HCHearing2", "HCHearing3", "HCHearing4", "highCourtOrder"],
  },
];
